import BundleProductOptionsOnLoadActionTypes from '../actionTypes/BundleProductOptionsOnLoadActionTypes';

export const productOptionsBundleOnLoadAction = (payload) => ({
    type: BundleProductOptionsOnLoadActionTypes.PRODUCTOPTIONSSELECTED_BUNDLE_ONLOAD,
    payload,
    sourceMiniPDP: false,
});
